import { Link } from 'react-router-dom';
import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import addpeopleapi from '../api/addpeopleapi';
import loginapi from '../api/accesstokenrouterapi';
import { FaPlusCircle } from "react-icons/fa";

import { APISERVERURL } from '../APIServerURL';
import Course from '../components/PeopleCard';

function ReceivedForms({accessToken,setAccessToken, setRefreshFailed}) {
  const navigate = useNavigate();
  const [registrationForms,setRegistrationForms]=useState([]);
  const [formListLoaded,setFormListLoaded]=useState(false);

  

  const loadForms=async ()=>{
    setFormListLoaded(false);
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await addpeopleapi.post('/getAllPeople',{},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setRegistrationForms(response.data.registrationForms);JSON.stringify(response.data.registrationForms);
      setFormListLoaded(true);
      //alert(JSON.stringify(response.data));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await addpeopleapi.post('/getAllPeople',{},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setRegistrationForms(response.data.registrationForms);JSON.stringify(response.data.registrationForms);
                      setFormListLoaded(true);
                      //alert(JSON.stringify(response.data));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
            setFormListLoaded(true);
          }
  }

  useEffect(()=>{
    loadForms();
  },[]);

 
const handleAddNewForm = async () => {
  navigate('/addpeople');
};

  return (
    <main className="w-full">
     <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">MEMBERS OF GSSS</h1>
          </div>
          <div className="w-full flex justify-end bg-gray-100 relative p-1 mt-1">            
            <button
              onClick={handleAddNewForm}
              disabled={!formListLoaded}
              className={`flex items-center gap-2 px-2 py-2 text-white text-xs rounded-lg shadow-md transition duration-300
                ${formListLoaded ? "bg-purple-600 hover:bg-purple-700" : "bg-gray-400 cursor-not-allowed"}`}
            >
              <FaPlusCircle className="w-5 h-5" />
              ADD MEMBER
            </button>
          </div>
        
        
          {formListLoaded && (
            <div className="w-full bg-gray-100 mt-2 py-1 flex flex-wrap gap-4 justify-center items-center min-h-[150px]">
              {registrationForms.length > 0 ? (
                registrationForms.map((form) => <Course key={form._id} post={form} />)
              ) : (
                <p className="text-gray-600 text-sm">No member to display. Click "Add Member" to add a new member.</p>
              )}
            </div>
          )}

          
     </div>
    {
   (!formListLoaded) && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </main>
  );
  }
  
  export default ReceivedForms